import { Helmet } from "react-helmet-async";
import { LandingCta } from "./home/LandingCta";
import { LandingFeatures } from "./home/LandingFeatures";
import { LandingFooter } from "./home/LandingFooter";
import { LandingHero } from "./home/LandingHero";
import { LandingIntegrations } from "./home/LandingIntegrations";
import { LandingModules } from "./home/LandingModules";
import { LandingNav } from "./home/LandingNav";

const SEO_TITLE = "Promang — prosjekt, service og dokumentasjon";
const SEO_DESCRIPTION =
  "Promang samler prosjektstyring, service, kvalitet, timer, dokumentasjon og integrasjoner i én plattform for moderne bedrifter.";

export const HomePage = () => {
  return (
    <>
      <Helmet prioritizeSeoTags>
        <html lang="nb" />
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={SEO_TITLE} />
        <meta property="og:description" content={SEO_DESCRIPTION} />
        <meta property="og:locale" content="nb_NO" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Promang" />
        <link rel="canonical" href="https://www.promang.no/" />
      </Helmet>

      <div className="min-h-screen bg-white antialiased">
        <LandingNav />
        <main>
          <LandingHero />
          <LandingFeatures />
          <LandingModules />
          <LandingIntegrations />
          <LandingCta />
        </main>
        <LandingFooter />
      </div>
    </>
  );
};
